class Jobs {
  constructor(el) {
    this.element = el;
    this.url = el.dataset.url;
    this.positions = [];
    this.departments = [];
    this.lang = document.documentElement.lang;
    this.departmentTagsContainerEl = el.querySelector('.js-jobs__departmentTags');
    this.locationTagsContainerEl = el.querySelector('.js-jobs__locationTags');
    this.positionsContainerEl = el.querySelector('.js-jobs__positions');
    this.filters = {};

    this.getPositions();
  }

  toggleFilter(el) {
    const { type, tag } = el.dataset;
    this.filters[type] = this.filters[type] === tag ? 'all' : tag;
    this.filter();
    el.blur();
  }

  filter() {
    const tagEls = this.element.querySelectorAll('.js-jobs__tag');
    [...tagEls].forEach((el) => {
      const isActive = (this.filters[el.dataset.type] || 'all') === el.dataset.tag;
      isActive ? el.classList.add('active') : el.classList.remove('active');
    });

    const positionEls = [...this.element.querySelectorAll('.jobs__position')];
    const shownPositionEls = positionEls.filter((el) => {
      return Object.entries(this.filters).every(([type, tag]) => {
        if ((tag || 'all') === 'all') {
          return true;
        }

        return el.dataset[type] === tag;
      });
    });
    const hiddenPositionEls = positionEls.filter((el) => !shownPositionEls.includes(el));

    shownPositionEls.forEach((el) => (el.style.display = 'flex'));
    hiddenPositionEls.forEach((el) => (el.style.display = 'none'));
  }

  getPositions() {
    return fetch(this.url)
      .then((response) => response.text())
      .then((str) => {
        const parser = new DOMParser();
        this.positions = parser.parseFromString(str, 'text/xml').getElementsByTagName('position');
        // Get all departments and locations
        const departments = [...this.positions].map((position) => {
          const category = position.getElementsByTagName('recruitingCategory')[0];
          return category ? category.textContent : 'Others';
        });
        const locations = [...this.positions].map((position) => position.getElementsByTagName('office')[0].textContent);
        // Remove repeated departments and locations
        this.departments = [...new Set(departments)];
        this.locations = [...new Set(locations)];
      })
      .then(() => this.render());
  }

  addTag(parentEl, type, tag) {
    const filter = document.createElement('button');
    filter.classList.add('button', 'button--tag', 'jobs__tag', 'js-jobs__tag');
    filter.textContent = tag === 'Others' ? translationObject.others : tag;
    filter.dataset.type = type;
    filter.dataset.tag = tag.toLowerCase();
    parentEl.appendChild(filter);
  }

  render() {
    this.departments.forEach((department) => this.addTag(this.departmentTagsContainerEl, 'department', department));
    this.locations.forEach((location) => this.addTag(this.locationTagsContainerEl, 'location', location));
    [...this.element.querySelectorAll('.js-jobs__tag')].forEach((el) =>
      el.addEventListener('click', () => this.toggleFilter(el))
    );

    Object.values(this.positions).forEach((position) => {
      const department = position.getElementsByTagName('recruitingCategory')[0];
      const p = {
        id: position.getElementsByTagName('id')[0].textContent,
        name: position.getElementsByTagName('name')[0].textContent,
        office: position.getElementsByTagName('office')[0].textContent,
        department: department ? department.textContent : 'Others',
        schedule: translationObject[position.getElementsByTagName('schedule')[0].textContent],
        type: translationObject[position.getElementsByTagName('employmentType')[0].textContent],
        viewJob: translationObject.viewJob,
      };

      const url = `https://data4life.jobs.personio.de/job/${p.id}?language=${this.lang}`;
      const posting = `
        <article data-department="${p.department.toLowerCase()}" data-location="${p.office.toLowerCase()}" class="jobs__position">
          <div class="jobs__title">
            <h6 class="jobs__name"><a class="jobs__link" href="${url}" target="_blank" rel="noopener noreferrer">
              ${p.name}</a></h6>
            ${p.type}, ${p.schedule} · ${p.office}
          </div>
          <a href="${url}" target="_blank" rel="noopener noreferrer" class="button jobs__button">${p.viewJob}</a>
        </article>
        `;

      this.positionsContainerEl.insertAdjacentHTML('beforeend', posting);
    });

    this.filter();
  }
}

function init() {
  [...document.querySelectorAll('.js-jobs')].forEach((el) => new Jobs(el));
}

export { init };
